module.exports = __webpack_public_path__ + "/images/ico-social-color-amazon.8048ae2.svg";